import { observer } from 'mobx-react';
import { MouseEvent, useCallback } from 'react';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { branchStore } from 'src/mobx/branchStore';
import { IBranch } from 'src/types/branches';
import MapMarker from 'src/view/components/Map/MapMarker/MapMarker';
import MapPin from 'src/view/components/Map/MapTooltip/MapTooltip';

const DeliveryZonesMapBranches = observer(() => {
  const selectBranch = useCallback((branch?: IBranch) => {
    if (!branch) return;

    if (branch) {
      deliveryZonesStore.mapStore.setCenter(branch.latitude, branch.longitude);
    }
    deliveryZonesStore.setTooltip(deliveryZonesStore.getBranchCoordinats(branch), { branch_name: branch.name });
  }, []);

  // prevent call click on area when we are clicking to branch pin
  const onClick = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  return (
    <>
      {branchStore.branches.map((branch) => (
        <MapPin<IBranch>
          onClick={onClick}
          key={branch.id}
          onSelect={selectBranch}
          value={branch}
          // options={[{ label: localeStore.t('zone_name'), value: getTranslate(branch.name) }]}
          Icon={<MapMarker iconName={Icons.MapLocation} />}
          latitude={branch.latitude}
          longitude={branch.longitude}
        />
      ))}
    </>
  );
});

export default DeliveryZonesMapBranches;
